import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app.js';

ReactDOM.render(
  <div>
    <App />
  </div>,
  document.getElementById('root')
);
